<template>
  <div
    :id="htmlId"
    class="obituary-threaded-comments__single threaded-comments-list-item"
  >
    <div class="obituary-threaded-comments__single-comment-wrapper">
      <div class="obituary-threaded-comments__single-comment-info">
        <p
          class="obituary-threaded-comments__single-name single-obituary-comment__name"
          v-html="comment.name"
        />

        <p class="obituary-threaded-comments__single-date" v-html="timeSince" />
      </div>

      <div class="obituary-threaded-comments__single-text-wrapper">
        <p
          ref="commentText"
          class="obituary-threaded-comments__single-text"
          v-html="comment.comment"
        />

        <threaded-comments-single-actions
          :comment="comment"
          :parent="parent"
          :attached="attached"
        />
      </div>

      <liked-comment-count :comment="comment" />
    </div>
  </div>
</template>

<script>
import { useDateFormatter } from 'Composables/useDateFormatter';
import LikedCommentCount from '../LikedCommentCount.vue';
import ThreadedCommentsSingleActions from './SingleActions.vue';

export default {
  name: 'ThreadedCommentsSingle',

  components: {
    LikedCommentCount,
    ThreadedCommentsSingleActions,
  },

  setup() {
    const { timeSinceDate, toValidDate, getLocale } = useDateFormatter();
    return { timeSinceDate, toValidDate, getLocale };
  },

  props: {
    comment: {
      type: Object,
      required: true,
    },
    parent: {
      type: Object,
      default: null,
    },
    attached: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    htmlId() {
      return `threaded-comment-${this.comment.id}`;
    },

    timeSince() {
      return this.timeSinceDate(this.comment.date);
    },
  },
};
</script>
